import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DomainDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"domain_disabled"}/>
}
